/* unplugin-vue-components disabled */
const DEF_LEN = 5
export default {
  mixins: [ModelValue(Array)],
  props: {
    maxLength: {
      type: Number, default: DEF_LEN
    }
  },
  emits: ['change'],
  data(){
    return {
      url: '',
      valid: true
    }
  },
  computed: {
    included(){
      return this.value.map(link => link.replace('https://', ''))
        .includes(this.url?.replace('https://', '') || '')
    },
    limit(){
      return this.value.length >= this.maxLength
    },
    can_add(){
      return !!this.url && this.valid && !this.included && !this.limit
    }
  },
  methods: {
    addLink(){
      this.value.push(this.url)
      this.url = ''
      this.$emit('change', this.value)
    },
    onDelete(i){
      this.value.splice(i, 1)
      this.$emit('change', this.value)
    }
  }
}
